import React from 'react'
import { Link } from 'react-router-dom'
import { scrollAppToTop } from '../../utils/scrollToTop'

const FOOTER_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About LMW', to: '/about' },
  { label: 'Explorer', to: '/search' },
  { label: 'Data Center', to: '/data-center' },
  { label: 'Methodology', to: '/methodology' },
]

function LandingFooter() {
  const handleLinkClick = () => {
    scrollAppToTop()
  }

  return (
    <footer className='landing-site-footer'>
      <div className='container landing-site-footer-inner'>
        <div className='landing-site-footer-top'>
          <div className='landing-site-footer-brand'>
            <span className='landing-site-footer-kicker'>Latin Macro Watch</span>
            <h2>Official macroeconomic data for Latin America and the Caribbean.</h2>
            <p>
              A unified platform developed by the Inter-American Development Bank to support evidence-based policy work,
              comparative research, and faster access to official regional series.
            </p>
          </div>

          <div className='landing-site-footer-columns'>
            <div className='landing-site-footer-column'>
              <h3>Platform</h3>
              <div className='landing-site-footer-links'>
                {FOOTER_LINKS.map(item => (
                  <Link key={item.to} to={item.to} onClick={handleLinkClick}>{item.label}</Link>
                ))}
              </div>
            </div>

            <div className='landing-site-footer-column'>
              <h3>Resources</h3>
              <div className='landing-site-footer-links'>
                <a href='https://dev.socrata.com/foundry/mydata.iadb.org/tbnd-z94f' target='_blank' rel='noreferrer'>API Documentation</a>
                <a href='https://data.iadb.org/dataset/latin-macro-watch-dataset' target='_blank' rel='noreferrer'>Access Dataset</a>
                <a href='https://mydata.iadb.org/Indicator-Catalog/Latin-Macro-Watch-Dataset/tbnd-z94f/about_data' target='_blank' rel='noreferrer'>IDB My Data</a>
                <Link to='/faq' onClick={handleLinkClick}>FAQ</Link>
                <a href='mailto:lmw@iadb.org'>Contact Us</a>
              </div>
            </div>
          </div>
        </div>

        <div className='landing-site-footer-meta'>
          <div className='landing-site-footer-citation'>
            <p>
              <strong>For citation use:</strong> Inter-American Development Bank, 2019, Latin Macro Watch Dataset, IDB Open Data,
              {' '}
              <a href='https://doi.org/10.60966/2n3c3oib' target='_blank' rel='noreferrer'>https://doi.org/10.60966/2n3c3oib</a>
            </p>
            <p>Creative Commons Attribution | Noncommercial | No Derivative Works 3.0 IGO</p>
          </div>

          <div className='landing-site-footer-notes'>
            <p><strong>Created by:</strong> Research Department and Fiscal Management Division - IDB - Latin Macro Watch - FISLAC</p>
            <p><strong>Disclaimer:</strong> The results offered in this database/dataset are those compiled by the authors and do not necessarily reflect the views of the Inter-American Development Bank, its Board of Directors, or the countries they represent.</p>
          </div>
        </div>

        <div className='landing-site-footer-bottom'>
          <span>Data Source: Latin Macro Watch by IDB</span>
          <span>&copy; 2026 Inter-American Development Bank</span>
        </div>
      </div>
    </footer>
  )
}

export default LandingFooter
